import styled from 'styled-components';

export const ManageTripCard = styled.div`
  background: linear-gradient(45deg, rgba(221, 214, 243, 0.20) 0%, rgba(250, 172, 168, 0.20) 100%), #FFF;
  border-radius: 16px;
  padding: 12px;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.20));
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: column;
  font-family: 'Rubik';
  font-weight: 400;
  left: 0;
  right: 0;
  margin-bottom: 32px;
  margin: 16px;
`;

export const BaggageIcon = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  height: 80px;
  width: 80px;
`;

export const Label = styled.p`
  color: #000;
  font-size: 16px;
  font-weight: 700;
  margin: 0px 0px 12px;
  width: 70%;
  letter-spacing: 0.308px;
  font-family: 'Rubik';
`;